(function($, root) {
  "use strict";

  $.renderIntro = function(introVid) {
    window.rdo.timer.hardpause = false;
    let data = {
      thumbnail: '',
      color: ''
    };
    let introTemplate = $.templates('#render-template-intro');
    $('intro').html(introTemplate.render(data));

    // window.rdo.video.fit = 0;
    window.rdo.video.currenttv = 'tvintro';
    window.rdo.video.mute = false;
    window.rdo.video.fit = 1.2;
    // window.rdo.video.currenttv = 'tv1';
    window.rdo.video.playerDefaults.autoplay = true;
    window.rdo.video.playerDefaults.fs = 0;
    // window.rdo.video.playerDefaults.modestbranding = 0;
    window.rdo.video.playerDefaults.controls = 0;

    // if (window.rdo.isMobile) {
    //   window.rdo.video.playerDefaults.autoplay = false;
    // }

    let onDone = function() {
      console.log('intro ondone');
      $(document).trigger('videoover');

    };

    let onPlay = function() {
      console.log('intro onplay');
      $('#' + window.rdo.video.currenttv).addClass('animated');
      if (window.rdo.video.numPlayAttempts < 1) {
        console.log('playing intro');
        // $.continueTimer();
        $.hideSpinner();
        $('#tvintro').show();

      }
      $.hideStartButton();

      setTimeout(function() {
        $.showSkipButton();
      }, 2500);

    };

    let onUnstarted = function() {
      // console.log('hiding intro');
      console.log('intro on unstart');
      $('intro .tv iframe').hide();
      $.showStartButton();

    }

    let onPause = function() {
      // console.log('PAUSEDDD');
      console.log('intro on pause');
      $.hideSpinner();
      $('intro .tv iframe').hide();
      $.showStartButton();
    };
    console.log('playing intro');

    $.playVideo(introVid, onDone, onPlay, onPause, onUnstarted);

  }

  $.renderTimelinePlayer = function() {
    // console.log('RENDERING TIMELINE PLAYER');

    let timelinePlayer = $.templates('#render-template-timeline-player');
    $('main').html(timelinePlayer.render(window.rdo.data));

    let vertical = $.templates('#render-template-vertical-timeline');
    $('#vertical-timeline').html(vertical.render(window.rdo.data));
    $('#vertical-timeline').getInitialScrollPositions('.sitem', '#vertical-timeline .wrapper');

    $('#vertical-timeline .wrapper').removeClass('fadeOut').addClass('fadeIn');
    // $('#vertical-timeline .wrapper .years').owlCarousel({
    //   // freeDrag:true,
    //   // items:10,
    //   // nav: true,
    //   items: 1,
    //   nav: true,
    //   autoplayHoverPause: true,
    //   animateOut: 'slideOutUp',
    //   animateIn: 'slideInUp'
    //
    // });

    // let initialsize = $('#vertical-timeline .years .year:first-child').innerHeight();
    // window.rdo.verticaltimeline.scroll.initialsize = initialsize;
  }

  $.renderTimelines = function() {
    // console.log('RENDERING TIMELINES');

    // let vertical = $.templates('#render-template-vertical-timeline');
    let horizontal = $.templates('#render-template-horizontal-timeline');
    // $('#vertical-timeline').html(vertical.render(window.rdo.data));
    $('#horizontal-timeline').html(horizontal.render(window.rdo.data.selected.subject));

    $('#horizontal-timeline ul').removeClass('fadeOut').addClass('fadeIn');

    $.scrollVerticalTimelinePos();
  }

  $.renderIndex = function() {
    window.rdo.timer.hardpause = false;
    let index = $.templates('#render-template-index');
    $('index').html(index.render(window.rdo.data));
  }

  $.renderModal = function(modalname) {
    window.rdo.timer.hardpause = false;
    let modal = $.templates('#render-template-modal');

    $('modal').html(modal.render(window.rdo.data.page[modalname]));

  }

  $.renderContent = function() {
    console.log('SHOULD RENDER CONTENT');
    window.rdo.timer.hardpause = false;

    //change body bg color before the content changes:
    if (window.rdo.previousBgColor) {
      $('body').addClass('pauseColorFade');

      $('body').css('background-color', window.rdo.previousBgColor);
    }
    if (window.rdo.audioPlayer && !window.rdo.isMobile) {
      window.rdo.audioPlayer.destroy();
      window.rdo.audioPlayer = null;
    }
    if (window.rdo.audioPlayerDetail && !window.rdo.isMobile) {
      window.rdo.audioPlayerDetail.destroy();
      window.rdo.audioPlayerDetail = null;
    }

    $.hideSpinner();

    //fade out previous
    // $('#content-player').addClass('fadeOut');
    // $('#full-page-background').animateCss('fadeOut');
    // $('#content-player').removeClass('fadeIn').addClass('fadeOut');
    $.hideContent();

    //on fade out done:
    $('#full-page-background').removeClass('fadeIn').animateCss('fadeOut', function() {
      $('body').removeClass('pauseColorFade');
      $('body').removeClass('dark-bg');

      // $.resetTimerAnimations();
      $.resetTimer();
      //delay the animations a little:
      // setTimeout(function() {
      console.log('RENDERING CONTENT');

      let displayTemplate = $.templates('#render-template-content-display');
      let detailTemplate = $.templates('#render-template-content-detail');
      let bgTemplate = $.templates('#render-template-content-background');

      // $('#content-player').removeClass('fadeOut').addClass('fadeIn');
      $.showContent();
      $.changePagePath();
      // console.log(window.rdo.data.selected.content);
      $('#content-player').html(displayTemplate.render(window.rdo.data.selected));

      $.startTimer();
      $.startTimerAnimations();

      $('#full-page-background').removeClass('fadeOut').addClass('fadeIn');
      $('#full-page-background').html(bgTemplate.render(window.rdo.data.selected));

      // console.log(window.rdo.data.selected.content);

      //render audio content:
      if (window.rdo.data.selected.content.format == 'audio') {

        $('#audio-player icon').css({
          'border-color': window.rdo.data.selected.content.color,
          'color': window.rdo.data.selected.content.color
        });

        if (!window.rdo.isMobile) {

          let divider = 2;

          // console.log('page height is: ' + window.rdo.page.pageheight);
          // console.log('text issss');
          // console.log('player size is: ' + window.rdo.page.pageheight / divider);

          // if (['smartphone', 'lanscape-smartphone'].indexOf(window.rdo.page.orientation) !== -1) {
          //   divider = 3;
          //
          // }
          window.rdo.audioPlayer = new $.caPlayer({
            audio: window.rdo.data.selected.content.audio.url,
            // audio: window.rdo.data.selected.content.short_audio.url,
            size: window.rdo.page.pageheight / divider,
            borderWidth: 2,
            // playedColor: window.rdo.data.selected.content.color,
            backgroundColor: $.hexToRgbA(window.rdo.data.selected.content.color, '.2'),
            // text: window.rdo.data.selected.content.post_title
            text: 'Dinlemek İçin Tıklayın'
          });
          // console.log(cap);
          // $('#audio-player').append(cap);
          window.rdo.audioPlayer.appendTo($('#audio-player')[0]);
          $('#audio-player .circle-audio-player').css('width', window.rdo.page.pageheight / divider + 'px');

          // $.pauseTimer(true);
          window.rdo.audioPlayer.audio.addEventListener('canplaythrough', (function() {
            // console.log('canplaythrough');

            let duration = window.rdo.audioPlayer.audio.duration * 1000;
            // duration = 2500;

            window.rdo.timer.timer.set({
              time: duration,
              autostart: false
            });

            //set timer duration:
            // $.setTimerAnimations(duration);
            $.setTimerAnimations();

            $.continueTimer();
            // $.playAudio();

          }).bind(this));
          window.rdo.audioPlayer.audio.addEventListener('play', (function() {
            $.pauseTimer(true);
            //adjust timer:
            // console.log('play');
            // $.continueTimer();
          }).bind(this));
          window.rdo.audioPlayer.audio.addEventListener('pause', (function() {
            $.continueTimer(true);
            window.rdo.timer.hardpause = false;
            //adjust timer:
            // console.log('pause');
            // $.pauseTimer();
          }).bind(this));
        } else {
          console.log('mobile audio_player');
          let divider = 2;

          $('#audio-player .audioPlayMobile').css('width', window.rdo.page.pageheight / divider + 'px');
          $('#audio-player .audioPlayMobile').css('height', window.rdo.page.pageheight / divider + 'px');

        }
        // window.rdo.audioPlayer.play();
      }

      //play video content:
      if (window.rdo.data.selected.content.format == 'video' && window.rdo.data.selected.content.video && !window.rdo.isMobile) {
        window.rdo.video.currenttv = 'theatre1';
        window.rdo.video.mute = false;
        window.rdo.video.fit = .75;
        window.rdo.video.playerDefaults.autoplay = true;
        window.rdo.video.playerDefaults.fs = 0;
        // window.rdo.video.playerDefaults.modestbranding = 1;
        window.rdo.video.playerDefaults.controls = 1;
        $.showSpinner();

        let onPlay = function() {
          $('#' + window.rdo.video.currenttv).addClass('active');

          if (window.rdo.video.numPlayAttempts < 1) {
            // $.continueTimer();

            $.hideSpinner();
            $.pauseTimer(true);
          }
          $.pauseTimer(true);
        };

        let onPause = function() {
          $.hideSpinner();
          // console.log('loaded?');
          $.continueTimer(true);
          window.rdo.timer.hardpause = false;
          // $.showSpinner();
          // $('#' + window.rdo.video.currenttv).removeClass('active');
        }
        let onDone = function() {

          $.continueTimer(true);
          window.rdo.timer.hardpause = false;
          // $.showSpinner();
          // $('#' + window.rdo.video.currenttv).removeClass('active');
        }
        // console.log('playing content video');
        $.playVideo(window.rdo.data.selected.content.video, onDone, onPlay, onPause);

      }
      //play/pause bg video (if not video content)
      else if (window.rdo.data.selected.content.background_video && window.rdo.video.ready && !window.rdo.isMobile) {

        window.rdo.video.currenttv = 'tv1';
        window.rdo.video.playerDefaults.autoplay = true;
        window.rdo.video.playerDefaults.fs = 0;
        // window.rdo.video.playerDefaults.modestbranding = 1;
        window.rdo.video.playerDefaults.controls = 0;
        window.rdo.video.fit = 1.25;

        window.rdo.video.mute = true;

        // console.log('rendering');

        $.showSpinner();

        let onDone = function() {
          window.rdo.video.tv.playVideo();
        };

        let onPlay = function() {
          $('#' + window.rdo.video.currenttv).addClass('active');
          if (window.rdo.video.numPlayAttempts < 1) {
            $.continueTimer();

            $.hideSpinner();
          }
        };

        let onPause = function() {
          $.showSpinner();
          $('#' + window.rdo.video.currenttv).removeClass('active');
        }
        // console.log('playing bg video ' + window.rdo.data.selected.content.background_video);
        $.playVideo(window.rdo.data.selected.content.background_video, onDone, onPlay, onPause);

      } else {
        $.cleanVideo();

      }

      //play/pause bg audio (if not video content)
      let audio_player = $("#background-sound");
      let source = audio_player.find('source');
      if (!window.rdo.data.selected.content.video && window.rdo.data.selected.content.background_sound) {

        source.attr('src', window.rdo.data.selected.content.background_sound.url);
        audio_player.trigger('load');
        audio_player.trigger('play');
      } else {
        audio_player.trigger('pause');
      }

      //play/pause bg video (if not video content)
      // if (!window.rdo.data.selected.content.video && window.rdo.data.selected.content.background_video && window.rdo.video.ready) {
      //
      //
      // } else if (!window.rdo.data.selected.content.video) {
      //   $.cleanVideo();
      // }

      //check if gallery content? then strip it:
      // let regexp = /\[gallery ids="(.*)"\]/gm;
      let regexp = /\[gallery(.*)\]/gm;
      let gallery = regexp.exec(window.rdo.data.selected.content.content);
      if (gallery) {
        // console.log('gallery items are: ' + gallery[0]); : [gallery ids="1,2,3,4"]
        // console.log('gallery items 2 are: ' + gallery[1]); 1,2,3,4
        window.rdo.data.selected.content.content = window.rdo.data.selected.content.content.replace(gallery[0], '');
        // let galleryItems = gallery[1].split(',');
        // console.log(galleryItems);

      }

      // if (window.rdo.data.selected.content.gallery) {
      //   console.log(window.rdo.data.selected.content.gallery_images);
      // }

      // });

      $('#content-detail').html(detailTemplate.render(window.rdo.data.selected));

      window.rdo.previousBgColor = window.rdo.data.selected.content.color;

      // }, window.rdo.transitions.transition);
    });

  };

})(jQuery, this);
